import type { PortableTextBlock } from "@portabletext/types";

function getBlockTextContent(
  children: PortableTextBlock["children"] | undefined,
): string {
  return (
    children
      ?.map((child) =>
        typeof child === "object" && "text" in child ? child.text : "",
      )
      .join("")
      .trim() ?? ""
  );
}

export { getBlockTextContent };
